import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
export default {
  name: 'Fullscreen',
  computed: {
    showFullScreenBtn: function showFullScreenBtn() {
      return window.navigator.userAgent.indexOf('MSIE') < 0;
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * 全屏方案
     */
    handleFullscreen: function handleFullscreen() {
      var name = this.$route.name;

      if (name === 'home' || name === 'serviceReport' || name === 'userHomeReport' || name === 'productReport') {
        this.$emit("showHomeFullScreen");
      } else {
        var main = document.body;

        if (this.value) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (main.requestFullscreen) {
            main.requestFullscreen();
          } else if (main.mozRequestFullScreen) {
            main.mozRequestFullScreen();
          } else if (main.webkitRequestFullScreen) {
            main.webkitRequestFullScreen();
          } else if (main.msRequestFullscreen) {
            main.msRequestFullscreen();
          }
        }
      }
    },
    handleChange: function handleChange() {
      this.handleFullscreen();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
    isFullscreen = !!isFullscreen;
    document.addEventListener('fullscreenchange', function () {
      _this.$emit('input', !_this.value);

      _this.$emit('on-change', !_this.value);
    });
    document.addEventListener('mozfullscreenchange', function () {
      _this.$emit('input', !_this.value);

      _this.$emit('on-change', !_this.value);
    });
    document.addEventListener('webkitfullscreenchange', function () {
      _this.$emit('input', !_this.value);

      _this.$emit('on-change', !_this.value);
    });
    document.addEventListener('msfullscreenchange', function () {
      _this.$emit('input', !_this.value);

      _this.$emit('on-change', !_this.value);
    });
    this.$emit('input', isFullscreen);
  }
};